<template>
  <div class="task-detail">
    <h2>任务详情</h2>
    <div v-if="loading" class="loading">
      正在加载...
    </div>
    <div v-else-if="taskDetails && taskDetails.length > 0">
      <table>
        <thead>
          <tr>
            <th>时间</th>
            <th>日收益</th>
            <th>日耗时</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(detail, index) in taskDetails" :key="detail.date">
            <td>{{ detail.date }}</td>
            <td class="daily-profit">
              {{ detail.daily_profit ||  '--' }}元
              <span v-if="index === lastValidProfitIndex && detail.daily_profit && status === '进行中'" class="completion-badge" :class="{
                'difficult': isTaskDifficult(detail.daily_profit),
                'achievable': !isTaskDifficult(detail.daily_profit)
              }">
                {{ isTaskDifficult(detail.daily_profit) ? `☹️按此金额还差${(this.taskProfit - (detail.daily_profit * parseInt(this.remainingTime.split('天')[0]) + this.currentAmount)).toFixed(2)}元` : '😊按此金额可完成' }}
              </span>
            </td>
            <td>{{ formatTime(detail.daily_elapsed_time) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="loading">
      暂无任务详情数据
    </div>
  </div>
</template>

<script>
import apiService from '../services/api.js'

export default {
  name: 'TaskDetail',
  data() {
    return {
      taskDetails: null,
      loading: true,
      taskProfit: 0,
      remainingTime: '',
      currentAmount: 0,
      status: ''
    }
  },
  computed: {
    lastValidProfitIndex() {
      if (!this.taskDetails) return -1;
      for (let i = this.taskDetails.length - 1; i >= 0; i--) {
        if (this.taskDetails[i].daily_profit) {
          return i;
        }
      }
      return -1;
    }
  },
  methods: {
    formatTime(seconds) {
      if (!seconds || isNaN(seconds)) return '-';
      
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = seconds % 60;
      
      return `${hours}时${minutes}分${remainingSeconds}秒`;
    },
    isTaskDifficult(dailyProfit) {
      if (!dailyProfit) return false;
      
      const remainingDays = parseInt(this.remainingTime.split('天')[0]) || 0;
      const expectedAmount = dailyProfit * remainingDays + this.currentAmount;
      return expectedAmount < this.taskProfit;
    }
  },
  async created() {
    try {
      const accountId = this.$route.params.id;
      const taskId = this.$route.params.taskId;
      this.taskProfit = parseFloat(this.$route.query.taskProfit) || 0;
      this.remainingTime = this.$route.query.remainingTime || '';
      this.currentAmount = parseFloat(this.$route.query.currentAmount) || 0;
      this.status = this.$route.query.status || '';
      
      const response = await apiService.getTaskDetail(accountId, taskId);
      this.taskDetails = response.data;
    } catch (error) {
      console.error('获取任务详情失败:', error);
      this.taskDetails = null;
    } finally {
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.task-detail {
  margin: 30px auto;
  max-width: 900px;
  padding: 0 20px;
}

h2 {
  color: #2c3e50;
  font-size: 24px;
  margin-bottom: 25px;
  font-weight: 600;
}

.detail-container {
  margin-top: 20px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

th, td {
  padding: 12px;
  text-align: center;
  border-bottom: 1px solid #ddd;
}

th {
  background: linear-gradient(180deg, #f1f5f9, #e2e8f0);
  font-weight: 700;
  color: #334155;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #e2e8f0;
}

td {
  color: #334155;
  font-size: 14px;
}

tr:last-child td {
  border-bottom: none;
}

.daily-profit {
  color: #10b981;
  font-weight: 600;
  position: relative;
}

.completion-badge {
  position: absolute;
  top: -5px;
  left: 60%;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  white-space: nowrap;
}

.completion-badge.difficult {
  background-color: #ef4444;
  color: white;
}

.completion-badge.achievable {
  background-color: #10b981;
  color: white;
}

.loading {
  color: #475569;
  margin-top: 20px;
  font-size: 14px;
}
</style>
